import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { CategoryGrid } from '../components/CategoryGrid';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-uncommon-black text-white selection:bg-uncommon-gold selection:text-black" data-id="element-280">
      <Header data-id="element-281" />
      <main data-id="element-282">
        <Hero data-id="element-283" />
        <CategoryGrid data-id="element-284" />
        <FeaturedProducts data-id="element-285" />
      </main>
      <Footer data-id="element-286" />
    </div>;
}